<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="6" sm="12" md="6">
          <ChemicalGrowth  />
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <ChemicalPestisides  />
        </v-col>
        <v-col cols="6" sm="12" md="6" >
          <ChemicalFertilizer />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ChemicalFertilizer from "./ChemicalFertilizer";
import ChemicalPestisides from "./ChemicalPestisides";
import ChemicalGrowth from "./ChemicalGrowth";

export default {
  components: {
    ChemicalFertilizer,
    ChemicalPestisides,
    ChemicalGrowth
  }
};
</script>
